<template>
  <div
    id="categoriesNavContainer"
    :class="{'fixed top-0 shadow border-0': isFixed}"
    class="bg-white w-full border-b py-4 border-gray-200"
  >
    <scrollactive
      id="categoriesNav"
      class="flex px-4 w-full overflow-x-scroll lg:overflow-hidden lg:block"
      active-class="isActive"
      v-on:itemchanged="myScrollPos"
      :modifyUrl="false"
      :offset="offset"
      :scroll-offset="offset"
    >
      <a
        :href="getCategorySlug(category)"
        class="scrollactive-item flex flex-shrink-0 mr-3 px-3 lg:inline-block lg:my-2"
        v-for="(category, index) in categories"
        :key="index"
        >{{ category }}</a
      >
    </scrollactive>
  </div>
</template>

<script>
module.exports = {
  data: function() {
    return {
      selectedCategory: "",
      isFixed: false,
      windowTop: 0,
      offset: 200,
    }
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    let app = this
    window.addEventListener("scroll", function() {
      app.windowTop = window.pageYOffset
      const element = document.getElementById("categoriesNavContainer")
      if (app.windowTop > element.offsetTop) {
        app.isFixed = true
      } else {
        app.isFixed = false
      }
    })
  },
  methods: {
    setActiveCategory(name) {
      this.selectedCategory = name
    },
    getCategorySlug(category) {
      return `#${category.replace(/\s+/g, "-").toLowerCase()}`
    },
    handleScroll() {
      this.categories.find((category) => {
        let c = category.replace(/\s+/g, "-").toLowerCase()
        const el = document.getElementById(c)
        console.log(el)
        if (this.elementInViewport(el)) {
          this.selectedCategory = category
        }
      })
    },
    elementInViewport(el) {
      let top = el.offsetTop
      let height = el.offsetHeight

      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
      }

      return (
        top >= window.pageYOffset &&
        top + height <= window.pageYOffset + window.innerHeight
      )
    },
    myScrollPos(event, currentItem) {
      let menu = document.getElementById("categoriesNav")
      let activeItem = currentItem
      console.log(this.offset)
      if (activeItem) {
        let myScrollPos = activeItem.offsetLeft - activeItem.clientWidth
        menu.scrollLeft = myScrollPos
      } else {
        menu.scrollLeft = 0
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.isActive {
  @apply bg-green-400 rounded-full text-white font-bold;
}
</style>
